import React, { useState } from 'react'

import { Button, Typography } from 'antd'

import { observer } from 'mobx-react-lite'

import { FlexBoxX } from 'common/components/boxes'
import { Page } from 'common/components/Page'
import { useQuery } from 'common/hooks/use-query'

import { useVendorStores } from 'vendor/hooks/use-stores'

import BillingAlert from './billing_alert'
import NewUsersModal from './new_users_modal'
import UsersTable from './users_table'

const ManageUsers = observer(() => {
  const { vendorSettingStore, userStore } = useVendorStores()
  const [newUsersModalVisible, setNewUsersModalVisible] = useState(false)

  useQuery(vendorSettingStore.indexUsers)

  // TODO: Not sure why width: 100% stretches beyond the edge but width 95% gets the job done
  return (
    <>
      <Page.Header>
        <FlexBoxX width="100%">
          <Typography.Title level={3} style={{ flexGrow: 1 }}>
            Users
          </Typography.Title>
          {userStore.canManageUsers && (
            <Button type="primary" onClick={() => setNewUsersModalVisible(true)}>
              Add new users
            </Button>
          )}
        </FlexBoxX>
        <Typography.Paragraph>Invite users to join your account.</Typography.Paragraph>
        <BillingAlert />
      </Page.Header>

      <Page.Content>
        <UsersTable />
      </Page.Content>
      <NewUsersModal visible={newUsersModalVisible} hide={() => setNewUsersModalVisible(false)} />
    </>
  )
})

export default ManageUsers
